import WithoutSidebar from "../../layouts/WithOutSidebar";
import "./PaymentDetails.css";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { ajax } from "../../scripts/helper";
import utils from "../../scripts/utils";
import { useSnackbar } from "notistack";
import CircleIcon from "@mui/icons-material/Circle";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Apartment, Bed, LocalPhone } from "@mui/icons-material";
import { differenceInCalendarDays } from "date-fns";

const PaymentDetails = () => {
  const params = useParams();
  const [transactionData, setTransactionData] = useState();
  const [transactionForm, setTransactionForm] = useState({
    action: "",
    method: "",
    params: {},
  });
  const { enqueueSnackbar } = useSnackbar();
  const formRef = useRef(null);
  const navigate = useNavigate();

  const transactionId = params.id;
  const transactionInquiryRequest = async () => {
    const res = await ajax({
      method: "GET",
      url: utils.urls.transactionInquiry(transactionId),
      snackbar: enqueueSnackbar,
      errmessage: "کد نا معتبر می باشد",
    }).catch((e) => {
      console.log("ERR:PaymentDetailPage:", e);
    });
    if (res && res.data) setTransactionData(res.data);
    else navigate("/", { replace: true });
  };

  const confirmTransaction = async () => {
    const res = await ajax({
      method: "GET",
      url: utils.urls.transactionConfirm(transactionId),
      snackbar: enqueueSnackbar,
    }).catch((e) => {
      console.log("ERR:PaymentDetailPage:confirmTransaction", e);
    });
    if (res && res.data) {
      setTransactionForm({
        action: res.data.paymentRedirectLink,
        method: res.data.redirectMethod === "QUERY_PARAM" ? "GET" : "POST",
        params: res.data.params,
      });
    }
  };

  const submitForm = () => {
    if (formRef && formRef.current) formRef.current.submit();
  };

  useEffect(() => {
    transactionInquiryRequest();
  }, []);

  useEffect(() => {
    console.log(formRef?.current?.action);
    submitForm();
  }, [transactionForm]);

  return (
    <WithoutSidebar footer={true}>
      <header>
        <div className="header-row">
          <img src="/images/tahagasht-h.svg" />
        </div>
      </header>
      <div style={{ width: "94%", margin: "0 auto" }}>
        <img
          src="/images/header.jpg"
          width={"100%"}
          style={{
            borderRadius: "20px",
            objectFit: "cover",
            maxHeight: "400px",
          }}
        />
      </div>
      <div
        className="PaymentDetails-container"
        // style={{ backgroundImage: "url(/images/bg-home.jpg)" }}
      >
        {/* <div className="PaymentDetails-container__background"></div> */}
        <div className="container">
          {transactionData ? (
            <>
              <div className="PaymentDetails-box">
                <form
                  ref={formRef}
                  action={transactionForm.action}
                  method={transactionForm.method}
                >
                  {Object.keys(transactionForm.params).map((param) => {
                    return (
                      <input
                        type="hidden"
                        name={param}
                        value={transactionForm.params[param]}
                        key={"pgwparam" + param}
                      />
                    );
                  })}
                </form>
                <div className="PaymentDetails-box__header">
                  ریز اطلاعات پرداخت{" "}
                </div>
                <div className="PaymentDetails-box__title">
                  <p>شما در حال پرداخت به شرکت</p>
                  <p> طاهاگشت به شرح ذیل هستید</p>
                </div>
                <div className="payment">
                  <div className="payment__with">
                    <div> پرداخت بابت</div>
                    <div className="amounts">
                      <p>مبلغ</p>
                      <p>{`(واحد پولی)`}</p>
                    </div>
                  </div>
                  <div className="tickets">
                    <div>{utils.services[transactionData.productName]}</div>
                    <div className="amounts">
                      <p>
                        {utils.e2p(transactionData.amount.toLocaleString())}
                      </p>
                      <p> {`(ریال)`}</p>
                    </div>
                  </div>
                </div>
                <div className="PaymentDetails-box__total">
                  <span> مبلغ قابل پرداخت </span>
                  <span>
                    {utils.e2p(transactionData.amount.toLocaleString())} ریال
                  </span>
                </div>
                <div className="wrapper-btn">
                  <button
                    className="PaymentDetails-box__btn"
                    onClick={confirmTransaction}
                  >
                    تایید وپرداخت
                  </button>
                </div>
              </div>
              {transactionData.reservation &&
                transactionData.reservation.flight && (
                  <div className="flights">
                    <div className="flight-list">
                      <div className="title">
                        <p>پرواز های رزرو شده</p>
                      </div>
                      {transactionData.reservation.flight.flightSegments.map(
                        (flight) => {
                          return (
                            <div className="single">
                              <div className="logo">
                                <img
                                  src={`https://cdn.tahagasht.com/images/airlines/${flight.airline.operating.code}.png`}
                                  alt="logo tahagasht"
                                />
                                <p>{`شماره پرواز`}</p>
                                <p>{`${flight.flightNumber}`}</p>
                              </div>
                              <div className="flight">
                                <div className="departure">
                                  <p className="text1">
                                    {utils.getTime(flight.departureDateTime)}
                                  </p>
                                  <p className="text2">
                                    {
                                      flight.departureAirport.airportNames.find(
                                        (e) => e.language == "fa"
                                      )?.name
                                    }
                                  </p>
                                  <p className="text3">
                                    {flight.departureAirport.code}
                                  </p>
                                </div>
                                <div className="detail-flight">
                                  <div className="detail-flight__row">
                                    <AirplanemodeActiveIcon />
                                  </div>
                                  <div
                                    className="divider"
                                    style={{ marginTop: "-15px" }}
                                  >
                                    <p>
                                      {utils.e2p(
                                        utils.getAlphabetDate(
                                          flight.departureDateTime
                                        )
                                      )}{" "}
                                    </p>
                                    <p></p>
                                    <p className="mobile-flightNo">{`شماره پرواز: ${flight.flightNumber}`}</p>
                                  </div>
                                  <div>
                                    <CircleIcon fontSize="13px" />
                                  </div>
                                </div>

                                <div className="departure">
                                  <p className="text1">
                                    {utils.getTime(flight.arrivalDateTime)}
                                  </p>
                                  <p className="text2">
                                    {" "}
                                    {
                                      flight.arrivalAirport.airportNames.find(
                                        (e) => e.language == "fa"
                                      )?.name
                                    }
                                  </p>
                                  <p className="text3">
                                    {flight.arrivalAirport.code}
                                  </p>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    {transactionData.reservation &&
                      transactionData.reservation.flight.airTravelers && (
                        <div className="passengers">
                          <div className="title">
                            <p>اطلاعات مسافران پرواز</p>
                          </div>
                          {transactionData.reservation.flight.airTravelers.map(
                            (passenger, index) => {
                              return (
                                <div className="single-passenger">
                                  <div className="detail">
                                    <div className="type">
                                      <p className="p1">
                                        {`مسافر ${index + 1}- `}{" "}
                                        {passenger.passengerType == "INF"
                                          ? " نوزاد"
                                          : passenger.passengerType == "CHD"
                                          ? " کودک"
                                          : " بزرگسال"}
                                      </p>
                                    </div>
                                    <div className="name">
                                      <p className="p2">
                                        {passenger.firstName +
                                          " " +
                                          passenger.lastName}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                  </div>
                )}
              {transactionData.reservation &&
                transactionData.reservation.hotel && (
                  <div className="hotel">
                    <div className="box-header"> لیست هتل های رزرو شده</div>
                    {transactionData.reservation.hotel.hotels?.map((hotel) => (
                      <div className="hotel-detail">
                        <p>
                          <Apartment />
                          {hotel.basicPropertyInfo?.hotelName}
                        </p>
                        <div className="hotel-loc">
                          <LocationOnIcon />
                          <div className="hotel-address">
                            <p>
                              {" "}
                              {hotel.basicPropertyInfo.city.name},
                              {hotel.basicPropertyInfo.city.country}
                            </p>
                            <p>{hotel.basicPropertyInfo.address}</p>
                          </div>
                        </div>
                        <div className="hotel-phone">
                          <LocalPhone />
                          {hotel.basicPropertyInfo.phones.join("  ")}
                        </div>
                        <div className="hotel-stay">
                          <div>
                            <p>Check-In:</p>
                            <p>{hotel.startDate}</p>
                          </div>
                          <div className="divider">
                            {differenceInCalendarDays(
                              new Date(hotel.endDate),
                              new Date(hotel.startDate)
                            )}{" "}
                            nights
                          </div>
                          <div>
                            <p>Check-Out:</p>
                            <p>{hotel.endDate}</p>
                          </div>
                        </div>
                        
                        {/* Rooms Table */}
                        {hotel.rooms && hotel.rooms.length > 0 && (
                          <div className="hotel-rooms">
                            <div className="rooms-header">
                              <Bed/>
                              <h4>اتاق های رزرو شده</h4>
                            </div>
                            <table className="rooms-table">
                              <thead>
                                <tr>
                                  <th>ردیف</th>
                                  <th>نوع اتاق</th>
                                  <th>نوع تغذیه</th>
                                  <th>مسافران</th>
                                </tr>
                              </thead>
                              <tbody>
                                {hotel.rooms.map((room, roomIndex) => (
                                  <tr key={roomIndex}>
                                    <td>{roomIndex + 1}</td>
                                    <td>
                                      {room.roomType?.roomTitles?.[0]?.title || 'نامشخص'}
                                    </td>
                                    <td>
                                      {room.roomType?.mealPlanCode === 'BB' ? 'صبحانه' : 
                                       room.roomType?.mealPlanCode === 'HB' ? 'نیمه پانسیون' :
                                       room.roomType?.mealPlanCode === 'FB' ? 'تمام پانسیون' :
                                       room.roomType?.mealPlanCode === 'AI' ? 'همه چیز شامل' :
                                       room.roomType?.mealPlanCode || 'نامشخص'}
                                    </td>
                                    <td>
                                      <div className="room-guests">
                                        {room.guests?.map((guest, guestIndex) => (
                                          <div key={guestIndex} className="guest-info">
                                            {guest.firstName} {guest.lastName}
                                            {guestIndex < room.guests.length - 1 && ', '}
                                          </div>
                                        )) || 'اطلاعات مسافر موجود نیست'}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
            </>
          ) : null}
        </div>
      </div>
    </WithoutSidebar>
  );
};
export default PaymentDetails;
